module.exports = __webpack_public_path__ + "img/framework.940b4b22.png";